'use strict';

var base = require('./base');
var quickViewBase = require('base/product/quickView');
var qtyInput = require('../components/quantityInput');
var clientValidation = require('../components/clientSideValidation');
var glideConfigs = require('../config/glideConfigs');
var glide = require('org/config/glide');

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start(false);
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        success: function (data) {
            $('body').append(data);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            clientValidation.invalid();
            clientValidation.clearErrorsOnChange();
            $.spinner().stop();
            qtyInput.qvInit();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = $.extend({}, quickViewBase, {
    showQuickview: function () {
        glide.sameClassMultiCarousel('glide', glideConfigs.plpQuickview);
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            if ($('#quickViewModal').length !== 0) {
                $('#quickViewModal').remove();
            }
            fillModalElement(selectedValueUrl);
        });

        // On QV image click navigate to PDP
        $('body').on('click', '.quick-view-dialog .primary-images a', function (e) {
            e.preventDefault();
            $('.quickview .full-pdp-link').trigger('click');
        });

        $('.slide-link').trigger('zoom.destroy');
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var purchasable = response.product.readyToOrder && response.product.available;
            var incomplete = response.product.availability.incompletecombo;
            var invalidcombo = response.product.availability.invalidcombo;
            var notpurchasable = invalidcombo || (!purchasable && !incomplete);

            $('button.add-to-cart').removeClass('purchasable not-purchasable incomplete invalidcombo');

            if (notpurchasable) {
                $('button.add-to-cart').addClass('not-purchasable');
            }
            if (purchasable) {
                $('button.add-to-cart').addClass('purchasable');
            }
            if (incomplete) {
                $('button.add-to-cart').addClass('incomplete');
            }
            if (invalidcombo) {
                $('button.add-to-cart').addClass('invalidcombo');
            }
            if (purchasable || (incomplete && !invalidcombo)) {
                $('button.add-to-cart').removeAttr('disabled');
            } else { // invalidcombo || notpurchasable || anything else
                $('button.add-to-cart').attr('disabled', 'disabled');
            }

            // update global add to cart (single products, bundles)
            var enableGlobal = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('button.add-to-cart-global', dialog).attr('disabled', !enableGlobal);
            if (response.product.availability.invalidcombo) {
                $('button.add-to-cart').text(response.resources.label_invalidcombo);
            } else if (response.product.availability.outofstock) {
                $('button.add-to-cart').text(response.resources.outofstock);
            } else {
                $('button.add-to-cart').text(response.resources.addtocart);
            }
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start(false);
            // hide controls now that the opacity is gone
            $('.product-carousel-arrows').addClass('d-none');
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).attr('data-pid', response.data.product.id).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').attr('data-pid', response.data.product.id).data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
                response.container.find('.product-id').text(response.data.product.sku);
                response.container.find('.price').html(response.data.product.price.html);
            }
            if (response.data.product.variationAttributes) {
                response.data.product.variationAttributes.forEach(function (attr) {
                    var $attrContainer = response.container.find('[data-attr="' + attr.id + '"] .attribute');
                    var $selectedAttrLabel = $attrContainer.find('.selected-attribute-label');

                    if (!$selectedAttrLabel.length) {
                        $selectedAttrLabel = $attrContainer.closest('.card').find('.selected-attribute-label');
                    }

                    if (attr.displayValue) {
                        const selectionText = attr.displayValue;
                        $selectedAttrLabel.text(selectionText);
                        $selectedAttrLabel.closest('.row-label').addClass('selected');
                        $selectedAttrLabel.closest('.attribute').addClass('selected').removeClass('selection-error');
                    } else {
                        $selectedAttrLabel.text($selectedAttrLabel.data('no-selection-msg'));
                        $selectedAttrLabel.closest('.row-label').removeClass('selected');
                        $selectedAttrLabel.closest('.attribute').removeClass('selected');
                    }
                });
            }
            // show slider controls again (hidden in beforeUpdateAttribute)
            $('.quick-view-dialog .product-carousel').on('init', () => {
                $('.product-carousel-arrows').removeClass('d-none');
            });
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // trigger on availability update
            if (!response) return;
        });
    },
    availability: base.availability,
    addToCart: base.addToCart
});
